var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateOnlyField(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1140_90121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49313 3.28666H12.6174V1.85437C12.6174 1.37992 12.9981 0.994995 13.4714 0.994995C13.9447 0.994995 14.3254 1.37992 14.3254 1.85437V3.28666H15.7488C17.005 3.28666 18.0263 4.31254 18.0263 5.57833V17.0367C18.0263 18.3007 17.005 19.3283 15.7488 19.3283H4.36166C3.10374 19.3283 2.08423 18.3007 2.08423 17.0367V5.57833C2.08423 4.31254 3.10374 3.28666 4.36166 3.28666H5.78506V1.85437C5.78506 1.37992 6.16581 0.994995 6.63909 0.994995C7.11237 0.994995 7.49313 1.37992 7.49313 1.85437V3.28666ZM3.7923 17.0367C3.7923 17.3518 4.04709 17.6096 4.36166 17.6096H15.7488C16.062 17.6096 16.3182 17.3518 16.3182 17.0367V7.87H3.7923V17.0367Z",
    fill: "#B4B4B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1140_90121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.942,
    height: 18.3333,
    fill: "white",
    transform: "translate(2.08423 0.994995)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateOnlyField);
export default __webpack_public_path__ + "static/media/date-only-field.55e2ebef209ccd629a2815f90d90a0e1.svg";
export { ForwardRef as ReactComponent };